import { getTermsOfUseUrl } from "@certn/utils";
import { useTranslation } from "react-i18next";

import { HelpAndPrivacyLinkItem } from "./HelpAndPrivacyLinkItem";
import { useLanguage } from "../../../hooks/useLanguage";

export function TermsOfUse() {
  const { t } = useTranslation();
  const { currentLanguageLabel } = useLanguage();
  const termsOfUseUrl = getTermsOfUseUrl(currentLanguageLabel);

  return (
    <HelpAndPrivacyLinkItem
      testID="help-and-privacy-terms-of-use-view-button"
      item={t("Terms of use")}
      description={t("Learn about our terms here")}
      linkText={t("View")}
      link={termsOfUseUrl}
    />
  );
}
